import { createContext } from 'react'

const authContext = createContext({
  authenticated: false,
  user: {},
  setAuthenticated: () => {}
})

export default authContext